// extracted by mini-css-extract-plugin
export var backContainer = "listGdd-module--back-container--f7d64";
export var backLink = "listGdd-module--back-link--89ec1";
export var backToSite = "listGdd-module--back-to-site--500c7";
export var imgLogo = "listGdd-module--img-logo--8686b";
export var listGdd = "listGdd-module--list-gdd--6a998";
export var titleGdd = "listGdd-module--title-gdd--4955d";